import { Component, OnInit, ViewEncapsulation, OnDestroy, Input } from '@angular/core';
import { Subscription, combineLatest } from 'rxjs';
import { AppState } from 'projects/bimbo/src/app/models/appState';
import { LogicService } from 'projects/bimbo/src/app/services/logic.service';
import { MatDialog } from '@angular/material';
import { DataSourceService } from 'projects/bimbo/src/app/services/data-source.service';
import { Contribution, ContributionSubTypesEnum, PayrollParameters, Parameter, LoanParameters, Employee, FinancialReturn, PeriodTypeEnum } from '@akiba/models_bimbo';
import { take } from 'rxjs/operators';
import { MatSelectChange } from '@angular/material';

@Component({
  selector: 'app-rs-statement',
  templateUrl: './rs-statement.component.html',
  styleUrls: ['./rs-statement.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class RsStatementComponent implements OnInit, OnDestroy {

  //////////////////////////////////////
  payrollParameter: PayrollParameters | null = null;
  retirementSavingParameter: Parameter | null = null;
  //////////////////////////////////////
  currentEmployee: Employee;
  //////////////////////////////////////

  @Input() contentLocation: AppState;
  displayedColumns: string[] = ['item', 'cost'];
  transactions: Array<any> = new Array();
  appLogicSubs: Subscription;
  loadContributionsSubs: Subscription;
  selectedYearTotalCompany = 0;
  selectedYearTotalEmployee = 0;
  pastTotalCompany = 0;
  pastTotalEmployee = 0;
  currentTotalCompany = 0;
  currentTotalEmployee = 0;
  groupData: any = {};

  totalEmployeePastYears = 0;
  totalCompanyPastYears = 0;
 /* totalEmployeePastSettlement = 0;
  totalCompanyPastSettlement = 0;*/
  totalPastYears = 0;

  totalEmployee = 0;
  totalCompany = 0;
  /*totalEmployeeSettlement = 0;
  totalCompanySettlement = 0;*/
  total = 0;
  totalInvestment = 0;
  totals: Array<any> = new Array<any>();
  totalCurrent: Array<any> = new Array<any>();
  totalPrevious: Array<any> = new Array<any>();

  ContributionArray = new Array<Contribution>();
  rendimientos = 0;
  totalPlusInvestment = 0;
  suraRetirement = 0;
  suraAmountCurrent = 0;
  payrollContributionArray = Array<any>();

  firstDate = new Date();
  pastYears = Array<any>();
  selectedYear = this.firstDate.getFullYear();
  newYear = this.firstDate.getFullYear();
  pastSura: any[];

  constructor(public logicService: LogicService, public dialog: MatDialog, private dataService: DataSourceService) {

    const parameters = this.logicService.dataManager.parameterDataLoader.parameters ? this.logicService.dataManager.parameterDataLoader.parameters : [];
    const payrollParameters = this.logicService.dataManager.parameterDataLoader.payrolls ? this.logicService.dataManager.parameterDataLoader.payrolls : [];
    this.currentEmployee = this.logicService.dataManager.proxyDataLoader.employee ? this.logicService.dataManager.proxyDataLoader.employee : this.logicService.dataManager.principalDataLoader.employee;

    this.retirementSavingParameter = parameters.filter(parameterObj => parameterObj.type === PeriodTypeEnum.retirementSaving).find(e => e.savingParameterAppliesTo(this.currentEmployee));
    const tempP = parameters.filter(parameterObj => parameterObj.type === PeriodTypeEnum.retirementSaving).find(e => e.loanParameterAppliesTo(this.currentEmployee));
    this.payrollParameter = payrollParameters.find(e => e.payrollAppliesTo(this.currentEmployee));

    if (this.currentEmployee.workInformation.employeeNumber) {

      const today = new Date();
      this.payrollContributionArray = Array<any>();
      this.sura();

      this.ContributionArray = this.currentEmployee.retirementSavingsData.map(rec => new Contribution(rec)).filter(c => c.subType !== ContributionSubTypesEnum.NotSet && c.subType.toUpperCase().includes('X') === false);

    }

  }

  ngOnInit() {

    const byYear = this.groupByCreatedDate(this.ContributionArray);
    if (byYear.hasOwnProperty(this.selectedYear)) {
      const year = byYear[this.selectedYear];
      Object.keys(year).forEach(month => {
        const monthInfo = year[month];
        this.payrollContributionArray = this.payrollContributionArray.concat(monthInfo);
      });
    }


  }

  async sura() {
    let timeYearFrom = new Date(this.selectedYear + '-01-01').getTime();
    let timeYearTo = new Date(this.selectedYear + 1 + '-01-01').getTime();
    let contributionSuraArray: Array<FinancialReturn>;
    /** subType SURAEY, SURART, SURARL */
    this.pastSura = await this.dataService.loadEmployeeContributions('CAR_SURAEY', this.currentEmployee.workInformation.employeeNumber).pipe(take(1)).toPromise().catch(error => {
      console.log(error);
      return [];
    });
    const carSura = await this.dataService.loadEmployeeContributions('CAR_SURA', this.currentEmployee.workInformation.employeeNumber, timeYearFrom, timeYearTo).pipe(take(1)).toPromise();
    const suraEY = await this.dataService.loadEmployeeContributions('CAR_SURAEY', this.currentEmployee.workInformation.employeeNumber, timeYearFrom, timeYearTo).pipe(take(1)).toPromise().catch(error => {
      console.log(error);
      return [];
    });
    // year   
    if (this.selectedYear === this.newYear) {
      contributionSuraArray = carSura.map((rec: any) => new FinancialReturn(rec));
    } else {
      contributionSuraArray = suraEY.map((rec: any) => new FinancialReturn(rec)).filter(e => e.regDate.getFullYear() === this.selectedYear);
    }
    const suraInt = contributionSuraArray.map(x => x.amount).reduce((p, n) => p + n, 0);
    this.suraRetirement = suraInt < 0 ? 0 : suraInt;

  }

  async totalRendimientos() {
    const timeCurrent = new Date(this.selectedYear + '-01-01').getTime();
    let timeYearTo = new Date(this.selectedYear + 1 + '-01-01').getTime();
    let contributionSuraCurret: Array<FinancialReturn>;
    this.totals = new Array<any>();
    this.totalCurrent = new Array<any>();
    this.totalPrevious = new Array<any>();
    this.rendimientos = 0;
    this.totalPlusInvestment = 0;

    const sharesArray  = this.currentEmployee.retirementSavingsData.map((rec: any) => rec)
    .filter(e => (e.subType === "CAR_DR" || e.subType === "CAR_DRE") && e.regDate.getFullYear() <= this.selectedYear);
    const sharesArrayCurrent = this.currentEmployee.retirementSavingsData.map((rec: any) => rec)
    .filter(e => (e.subType === "CAR_DR" || e.subType === "CAR_DRE") && e.regDate.getFullYear() === this.selectedYear);
    const sharesArrayPast = this.currentEmployee.retirementSavingsData.map((rec: any) => rec)
    .filter(e => (e.subType === "CAR_DR" || e.subType === "CAR_DRE") && e.regDate.getFullYear() < this.selectedYear);
    //suraEY 
    const currentSura = await this.dataService.loadEmployeeContributions('CAR_SURA', this.currentEmployee.workInformation.employeeNumber, timeCurrent, timeYearTo).pipe(take(1)).toPromise().catch(error => {
      console.log(error);
      return [];
    });

    this.sura().then(() => {

    let sharesTotal = sharesArray.map(x => x.investmentReturn).reduce((p, n) => p + n, 0);
    let sharesCurrent = sharesArrayCurrent.map(x => x.investmentReturn).reduce((p, n) => p + n, 0);
    let sharesPast = sharesArrayPast.map(x => x.investmentReturn).reduce((p, n) => p + n, 0);
    this.rendimientos = sharesTotal < 0 ? 0 : sharesTotal;
    const sumRendimientosCurrent = sharesCurrent;
    const sumRendimientosPast = sharesPast;

    /** si el año seleccionado es el año actual o no */
    if (this.selectedYear == this.newYear) {
      contributionSuraCurret = currentSura.map((rec: any) => new FinancialReturn(rec));
    } else {
      contributionSuraCurret = this.pastSura.map((rec: any) => new FinancialReturn(rec)).filter(e => e.regDate.getFullYear() === this.selectedYear);
    }
    this.suraAmountCurrent = contributionSuraCurret.map(x => x.amount).reduce((p, n) => p + n, 0);
    const suraPastEY: Array<FinancialReturn> = this.pastSura ? this.pastSura.map((rec: any) => new FinancialReturn(rec)).filter(e => e.regDate.getFullYear() == (this.selectedYear - 1)): [];

    // SURART y SURARL 
    const contributionSuraRT = this.currentEmployee.retirementSavingsData.map((rec: any) => new Contribution(rec)).filter(e => e.subType.includes('_SURART') && e.regDate.getFullYear() === this.selectedYear);
    const contributionSuraPastRT = this.currentEmployee.retirementSavingsData.map((rec: any) => new Contribution(rec)).filter(e => e.subType.includes('_SURART') && e.regDate.getFullYear() < this.selectedYear);
    const contributionSuraPastRL = this.currentEmployee.retirementSavingsData.map((rec: any) => new Contribution(rec)).filter(e => e.subType.includes('_SURARL') && e.regDate.getFullYear() <= this.selectedYear);

    const suraAmountRT = contributionSuraRT.length > 0 ? contributionSuraRT.map(x => x.investmentReturn).reduce((p, n) => p + n, 0) : 0;
    const suraAmountPastRT = contributionSuraPastRT.length > 0 ? contributionSuraPastRT.map(x => x.investmentReturn).reduce((p, n) => p + n, 0) : 0;
    // validar si habra rendimiento liquidado
    const suraAmountPastRL = contributionSuraPastRL.length > 0 ? contributionSuraPastRL.map(x => x.investmentReturn).reduce((p, n) => p + n, 0) : 0;
    const amountPastEY = suraPastEY.map(x => x.amount).reduce((p, n) => p + n, 0);

    const rendimientosCurrent = sumRendimientosCurrent < 0 ? 0 + this.suraAmountCurrent - amountPastEY + suraAmountRT : sumRendimientosCurrent + this.suraAmountCurrent - amountPastEY + suraAmountRT;
    const rendimientosPast = sumRendimientosPast < 0 ? 0 + amountPastEY : sumRendimientosPast + amountPastEY + suraAmountPastRT;
    
    this.totalPlusInvestment = this.rendimientos + this.total + this.suraRetirement;

    const t1 = {
      text: 'Total Ahorrado Acumulado',
      total: this.total

    };
    const t11 = {
      text: 'Total Rendimiento Acumulado',
      total: this.rendimientos + this.suraRetirement
    };

    const totalA = {
      text: 'Total Neto Acumulado',
      total: this.totalPlusInvestment
    };

    this.totals.push(t1);
    this.totals.push(t11);
    this.totals.push(totalA);

    /** total del año  */
    const t2 = {
      text: 'Total Ahorrado del Año',
      total: this.currentTotalCompany + this.currentTotalEmployee,// + this.totalEmployeeSettlement + this.totalCompanySettlement,
      note: 'Total aportaciones de ahorro nómina del año vigente o consultado'
    };

    const t21 = {
      text: 'Total Rendimiento del Año',
      total: rendimientosCurrent,
      note: 'Total rendimiento del año vigente o consultado'
    };

    const tYear = {
      text: 'Total Neto del Año',
      total: t2.total + t21.total
    };

    this.totalCurrent.push(t2);
    this.totalCurrent.push(t21);
    this.totalCurrent.push(tYear);

    const t3 = {
      text: 'Total Ahorrado de Años Anteriores',
      total: this.totalCompanyPastYears + this.totalEmployeePastYears, //+ this.totalCompanyPastSettlement + this.totalEmployeePastSettlement,
      note: 'Total aportaciones de ahorro nómina de años anteriores al consultado'
    };

    const t31 = {
      text: 'Total Rendimiento de Años Anteriores',
      total: rendimientosPast,
      note: 'Total rendimientos de años anteriores al consultado'
    };

    const tPrev = {
      text: 'Total Neto de Años Anteriores',
      total: t3.total + t31.total
    };

    this.totalPrevious.push(t3);
    this.totalPrevious.push(t31);
    this.totalPrevious.push(tPrev);

  });
  }


  get rfc(): string {
    return this.currentEmployee.workInformation.companyRef.taxationIdentificationNumber;
  }

  get shouldShowStatement(): boolean {
    return this.total > 0;
  }

  get companyName(): string {
    return this.currentEmployee.workInformation.companyRef.companyName;
  }

  get displayName(): string {
    return this.currentEmployee.displayName;
  }

  get department(): string {
    return this.currentEmployee.workInformation.department.departmentName;
  }

  get employeeRFC(): string {
    return this.currentEmployee.taxationIdentificationNumber;
  }

  get employeeNumber(): string {
    return this.currentEmployee.workInformation.employeeNumber;
  }

  get departmentID(): string {
    return this.currentEmployee.workInformation.department.departmentID;
  }

  get totalCost(): number {
    return 0;
  }

  get currentYear(): string {
    const now = new Date();
    return now.getFullYear().toString();
  }

  get downloadURLLink(): string | null {

    const asp = this.retirementSavingParameter;
    if (asp) {
      return asp.savingParameter.downloadLink();
    }

    return null;

  }

  get factor(): number {
    const p = this.retirementSavingParameter;
    if (p) {
      return p.savingParameter.factor;
    }
    return 0;
  }





  selectedPeriodChange(event: MatSelectChange) {
    this.payrollContributionArray = Array<any>();
    if (!event.value) {
      let dateYear = new Date();
      this.selectedYear = dateYear.getFullYear();
    } else {

      this.selectedYear = event.value;
      const byYear = this.groupByCreatedDate(this.ContributionArray);
      if (byYear.hasOwnProperty(this.selectedYear)) {
        const year = byYear[this.selectedYear];
        Object.keys(year).forEach(month => {
          const monthInfo = year[month];
          this.payrollContributionArray = this.payrollContributionArray.concat(monthInfo);
        });
      }

    }

  }

  cancel(tabIndex: number, contentIndex: number | null) {
    this.contentLocation.tabIndex = tabIndex;
    this.contentLocation.contentIndex = contentIndex;
  }

  groupByCreatedDate(pc: Array<Contribution>): any {

    const months = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
    this.totalEmployeePastYears = 0;
    this.totalCompanyPastYears = 0;
    /*this.totalCompanyPastSettlement = 0;
    this.totalEmployeePastSettlement = 0;
    this.totalCompanySettlement = 0;
    this.totalEmployeeSettlement = 0;*/

    this.totalPastYears = 0;
    this.totalEmployee = 0;
    this.totalCompany = 0;
    this.total = 0;
    this.totalInvestment = 0;
    this.currentTotalCompany = 0;
    this.currentTotalEmployee = 0;

    const today = new Date();
    const currentYear = this.selectedYear;
    const group: any = {};
    const years = [this.newYear]
    pc.forEach((element: Contribution) => {

      const year = element.regDate.getFullYear();
      const month = element.regDate.getMonth();

      if (year > 2020) {
        years.push(year);
      }

      if (group.hasOwnProperty(year)) {

        if (group[year].hasOwnProperty(month)) {

          const monthInfo = group[year][month];
          monthInfo.month = months[month];
          monthInfo.year = year;
          monthInfo.companyAmount = monthInfo.companyAmount + element.companyAmount;
          monthInfo.employeeAmount = monthInfo.employeeAmount + element.employeeAmount;
          monthInfo.subTotal = (monthInfo.companyAmount + monthInfo.employeeAmount);

          group[year][month] = monthInfo;

        } else {

          const monthInfo: any = {};
          monthInfo.month = months[month];
          monthInfo.year = year;
          monthInfo.companyAmount = element.companyAmount;
          monthInfo.employeeAmount = element.employeeAmount;
          monthInfo.subTotal = (monthInfo.companyAmount + monthInfo.employeeAmount);

          group[year][month] = monthInfo;
        }

      } else {

        const monthInfo: any = {};
        monthInfo.month = months[month];
        monthInfo.year = year;
        monthInfo.companyAmount = element.companyAmount;
        monthInfo.employeeAmount = element.employeeAmount;
        monthInfo.subTotal = (monthInfo.companyAmount + monthInfo.employeeAmount);
        group[year] = { [month]: monthInfo };

      }

      if (year < currentYear) {
       /* if(element.subType === "CAR_AL"){
          this.totalEmployeePastSettlement += element.employeeSettlement ;
          this.totalCompanyPastSettlement += element.companySettlement ;
        }*/
        this.totalEmployeePastYears += element.employeeAmount;
        this.totalCompanyPastYears += element.companyAmount;
        this.totalPastYears = this.totalEmployeePastYears + this.totalCompanyPastYears; // + this.totalEmployeePastSettlement + this.totalCompanyPastSettlement;

      } else if (year === this.selectedYear) {
      /*  if(element.subType === "CAR_AL"){
          this.totalEmployeeSettlement += element.employeeSettlement ;
          this.totalCompanySettlement += element.companySettlement ;
        }*/

        this.currentTotalCompany += element.companyAmount;
        this.currentTotalEmployee += element.employeeAmount;
      }

      this.totalEmployee = this.totalEmployeePastYears + this.currentTotalEmployee; // + this.totalEmployeeSettlement + this.totalEmployeePastSettlement;
      this.totalCompany = this.totalCompanyPastYears + this.currentTotalCompany; // + this.totalCompanySettlement + this.totalCompanyPastSettlement;
      this.total = this.totalEmployee + this.totalCompany;
      this.totalInvestment += element.investmentReturn;

      const dataArr = new Set(years);
      this.pastYears = Array.from(dataArr);

    });

    this.totalRendimientos();
    return group;

  }

  ngOnDestroy(): void {

    if (this.appLogicSubs && !this.appLogicSubs.closed) {
      this.appLogicSubs.unsubscribe();
      this.appLogicSubs = null;
    }

    if (this.loadContributionsSubs && !this.loadContributionsSubs.closed) {
      this.loadContributionsSubs.unsubscribe();
      this.loadContributionsSubs = null;
    }

  }

}
